import React from "react";
import { DateColumn } from "widgets/grid/cells/DateColumn";
import PreviewActionsCell  from "../cells/PreviewActions";
import { PreviewName } from "../cells/PreviewName";
import StatusColumn from "../cells/StatusColumn";
import SelectCell from "../cells/SelectCell";
import { TYPES } from "utils/constants";
import SelectAllPreviewsCell from "../cells/SelectAllPreviewsCell";

function genRowId(data, str){
	return `${str}-${data}`;
}

export const CREATIVE_PREVIEWS_COLUMNS = [
	{
		...SelectCell,
		headerRenderer: () => <SelectAllPreviewsCell />,
		getRowMetaData(data){
			return {
				type: TYPES.PREVIEWS,
				isSelected: data.isSelected || false,
				checkboxId: genRowId(data.id, TYPES.PREVIEWS),
				id: data.id,
			};
		},
		locked:false,
	},
	{
		key: "name",
		name: "Name",
		width: 350,
		resizable: true,
		formatter: PreviewName,
		sortable: true,
		getRowMetaData(data) {
			const { type } = data;
			return { type };
		},
	},
	{
		key: "status",
		name: "Status",
		formatter: (props) => {
			const { dependentValues = {} } = props;
			return <StatusColumn value={dependentValues?.status} />;
		},
		sortable: false,
		width:130,
		locked: false,
		getRowMetaData(data){
			const { status } = data;
			return { status };
		},
	},
	PreviewActionsCell,
	{
		key: "publicUrlTiA",
		name: "Creative Preview",
		width: 375,
		sortable: false,
		resizable: true,
		formatter: ({ value }) => <a href={value} target="_blank">{value}</a>,
	},
	{
		key: "publicUrlVV",
		name: "Versions Preview",
		width: 375,
		sortable: false,
		resizable: true,
		formatter: ({ value }) => <a href={value} target="_blank">{value}</a>,
	},
	{
		key: "dateCreated",
		name: "Date Created",
		width: 140,
		formatter: DateColumn,
		sortable: true,
		resizable: true,
	},
	{
		key: "dateExpires",
		name: "Date Expires",
		width: 140,
		formatter: DateColumn,
		sortable: true,
		resizable: true,
	},
];
